export default __webpack_public_path__ + "static/media/ico-sq-8-work.9e4853a5.svg";